import { environment } from "../../../environments/environment";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { endpointsURL } from "src/app/constants/endpointsURL";
import { CampoValorLI } from "src/app/maintenance-royal-decree/models/availablefields.model";

@Injectable({
  providedIn: "root",
})
export class ListValueService {
  env = environment.env;
  listValuesEtiquetasURL = endpointsURL.listValuesEtiquetasURL;
  listValuesFabricantesURL = endpointsURL.listValuesFabricantesURL;
  listValuesFormatosImpresionURL = endpointsURL.listValuesFormatosImpresionURL;
  listValuesMarcasURL = endpointsURL.listValuesMarcasURL;
  listValuesPlantillasActivasURL = endpointsURL.listValuesPlantillasActivasURL;
  listValuesTiposDeDocumentoURL = endpointsURL.listValuesTiposDeDocumentoURL;
  listValuesTiposDeDocumentoSimpleURL =
    endpointsURL.listValuesTiposDeDocumentoSimpleURL;
  listsValuesConcesionariosURL = endpointsURL.listsValuesConcesionariosURL;
  listsValuesPerfilesURL = endpointsURL.listsValuesPerfilesURL;
  listValuesAnalistasURL = endpointsURL.listValuesAnalistasURL;
  listValuesAnalistasActivosURL = endpointsURL.listValuesAnalistasActivosURL;
  listValuesAnalistasBuzonURL = endpointsURL.listValuesAnalistasBuzonURL;
  listValuesAnalistasBuzonCocURL = endpointsURL.listValuesAnalistasBuzonCocURL;
  listValuesAnalistasConsultaCocURL =
    endpointsURL.listValuesAnalistasConsultaCocURL;
  listValuesCertificatesURL = endpointsURL.listValuesCertificatesURL;
  listValuesEstadosURL = endpointsURL.listValuesEstadosURL;
  listValuesReformsURL = endpointsURL.listValuesReformsURL;
  listValuesReformsPadreURL = endpointsURL.listValuesReformsPadreURL;
  listValuesUsersURL = endpointsURL.listValuesUsersURL;
  listValuesMotorURL = endpointsURL.listValuesMotorURL;
  listValuesTipoVehiculoURL = endpointsURL.listValuesTipoVehiculoURL;
  listValuesMotivosRechazoURL = endpointsURL.listValuesMotivosRechazoURL;
  requestURL = endpointsURL.requestURL;
  anchoNeumaticoURL = endpointsURL.anchoNeumaticoURL;
  perfilNeumatico = endpointsURL.perfilNeumaticoURL;
  diametroNeumatico = endpointsURL.diametroNeumaticoURL;
  indiceCarga = endpointsURL.indiceCargaURL;
  simbolosIndiceVelocidad = endpointsURL.simbolosIndiceVelocidadURL;
  gargantaNeumatico = endpointsURL.gargantaNeumaticoURL;
  bombeoNeumatico = endpointsURL.bombeoNeumaticoURL;
  modelo = endpointsURL.listModeloURL;
  tiposMotor = endpointsURL.listTiposMotorURL;
  tipoCambio = endpointsURL.listTipoCambioURL;
  motivosReedicion = endpointsURL.listMotivosReedicion;
  tipoPlaca = endpointsURL.listTipoPlaca;
  motoresURL = endpointsURL.motoresURL;
  clasificacionesURL = endpointsURL.clasificacionesURL;
  categoriasURL = endpointsURL.categoriasURL;
  specificFieldsURL = endpointsURL.specificFieldsURL;
  listBastidoresCOCURL = endpointsURL.listBastidoresCOCURL;
  listhBastidoresCOCURL = endpointsURL.listHBastidoresCOCURL;
  listValuesCamposLI = endpointsURL.listValuesCamposLI;
  listValuesEstadosPorPantalla = endpointsURL.listValuesEstadosPorPantalla;

  constructor(private httpClient: HttpClient) {}

  public listValuesEtiqueta(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.listValuesEtiquetasURL}lista`
    );
  }

  public listValuesCommentsHistory(id: string): Observable<any[]> {
    let params = new HttpParams().set("_identificador", id);
    return this.httpClient.get<any[]>(
      `${this.env}${this.listValuesEtiquetasURL}HistoriaComentarios`,
      { params: params }
    );
  }
  public listValuesReleases(id: string): Observable<any[]> {
    let params = new HttpParams().set("_identificador", id);
    return this.httpClient.get<any[]>(
      `${this.env}${this.listValuesEtiquetasURL}VersionesPeticion`,
      { params: params }
    );
  }

  public listValuesFabricantes(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.listValuesFabricantesURL}`
    );
  }

  public listValuesFormatosImpresion(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.listValuesFormatosImpresionURL}`
    );
  }

  public listValuesMarcas(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.env}${this.listValuesMarcasURL}`);
  }

  public listaTipoDeDocumento(): any {
    return this.httpClient.get<any>(
      `${this.env}${this.listValuesTiposDeDocumentoURL}`
    );
  }

  public listaSimpleTipoDeDocumento(): any {
    return this.httpClient.get<any>(
      `${this.env}${this.listValuesTiposDeDocumentoSimpleURL}`
    );
  }

  public listaPlatillasActivas(): any {
    return this.httpClient.get<any>(
      `${this.env}${this.listValuesPlantillasActivasURL}`
    );
  }

  public listaConcesionarios(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.listsValuesConcesionariosURL}/lista`
    );
  }
  public listaConcesionariosActivos(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.listsValuesConcesionariosURL}/lista/activos`
    );
  }
  public listaPerfiles(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.listsValuesPerfilesURL}/lista`
    );
  }

  public listaAnalistas(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.listValuesAnalistasURL}`
    );
  }

  public listaAnalistasActivos(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.listValuesAnalistasActivosURL}`
    );
  }

  public listaAnalistasBuzon(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.listValuesAnalistasBuzonURL}`
    );
  }

  public listaAnalistasBuzonCoc(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.listValuesAnalistasBuzonCocURL}`
    );
  }

  public listaAnalistasConsultaCoc(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.listValuesAnalistasConsultaCocURL}`
    );
  }

  public listCertificates(
    tipo: string,
    seeNotExcluded: string
  ): Observable<any[]> {
    let params = new HttpParams()
      .set("tipo", tipo)
      .set("seeNotExcluded", seeNotExcluded);
    return this.httpClient.get<any[]>(
      `${this.env}${this.listValuesCertificatesURL}`,
      { params: params }
    );
  }

  public listEstados(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.listValuesEstadosURL}`
    );
  }

  public listReforms(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.listValuesReformsURL}`
    );
  }

  public listReformsPadre(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.listValuesReformsPadreURL}`
    );
  }

  public certificatesExpiredByRole(role: string): Observable<any[]> {
    let params = new HttpParams().set("_perfil", role);
    return this.httpClient.get<any[]>(
      `${this.env}${this.listValuesUsersURL}/FechaCertificadoCaducada`,
      {
        params: params,
      }
    );
  }
  // Listas de DBLIST
  public listAnchoNeumatico(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.env}${this.anchoNeumaticoURL}`);
  }

  public listPerfilNeumatico(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.env}${this.perfilNeumatico}`);
  }

  public listDiametroNeumatico(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.env}${this.diametroNeumatico}`);
  }

  public listIndiceCarga(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.env}${this.indiceCarga}`);
  }

  public listIndiceVelocidad(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.simbolosIndiceVelocidad}`
    );
  }

  public listSimbolosIndiceVelocidad(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.simbolosIndiceVelocidad}`
    );
  }

  public listGargantaNeumatico(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.env}${this.gargantaNeumatico}`);
  }

  public listBombeoNeumatico(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.env}${this.bombeoNeumatico}`);
  }

  public listMotivosRechazo(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.listValuesMotivosRechazoURL}`
    );
  }

  public listMotores(bastidor: any): Observable<any[]> {
    let params = new HttpParams().set("_bastidor", bastidor);
    return this.httpClient.get<any[]>(`${this.env}${this.motoresURL}`, {
      params: params,
    });
  }

  public listClasificaciones(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.env}${this.clasificacionesURL}`);
  }

  public listCategorias(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.env}${this.categoriasURL}`);
  }

  public listCodigoMotor(bastidor: any): Observable<any[]> {
    let params = new HttpParams().set("_bastidor", bastidor);

    return this.httpClient.get<any[]>(`${this.env}${this.tiposMotor}`, {
      params: params,
    });
  }

  public listModeloTipo(bastidor: any): Observable<any[]> {
    let params = new HttpParams().set("_bastidor", bastidor);

    return this.httpClient.get<any[]>(`${this.env}${this.modelo}`, {
      params: params,
    });
  }
  public listTipoPlaca(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.env}${this.tipoPlaca}`);
  }
  public listMotivosReedicion(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.env}${this.motivosReedicion}`);
  }

  public listTipoCambio(bastidor: any, modelo: any): Observable<any[]> {
    let params = new HttpParams();
    params = params.append("_bastidor", bastidor);
    params = params.append("_tmotor", modelo);

    return this.httpClient.get<any[]>(`${this.env}${this.tipoCambio}`, {
      params: params,
    });
  }

  public listDenominaciones(bastidor, certificado, reforma, tmotor) {
    let params = new HttpParams();
    params = params.append("_bastidor", bastidor);
    params = params.append("_reforma", reforma);
    params = params.append("_certificado", certificado);
    params = params.append("_tmotor", tmotor);
    return this.httpClient.get<any[]>(
      `${this.env}${this.specificFieldsURL}Denominaciones`,
      {
        params: params,
      }
    );
  }

  public listSiglas(bastidor, certificado, reforma, tmotor) {
    let params = new HttpParams();
    params = params.append("_bastidor", bastidor);
    params = params.append("_reforma", reforma);
    params = params.append("_certificado", certificado);
    params = params.append("_tmotor", tmotor);
    return this.httpClient.get<any[]>(
      `${this.env}${this.specificFieldsURL}Siglas`,
      {
        params: params,
      }
    );
  }

  public listMotor() {
    return this.httpClient.get<any[]>(`${this.env}${this.listValuesMotorURL}`);
  }
  public listTipoVehiculo() {
    return this.httpClient.get<any[]>(
      `${this.env}${this.listValuesTipoVehiculoURL}`
    );
  }

  public listBastidoresCOC(idPetition: string, release: string) {
    let params = new HttpParams()
      .set("solicitud", idPetition)
      .set("release", release);

    return this.httpClient.get<any[]>(
      `${this.env}${this.listBastidoresCOCURL}`,
      { params: params }
    );
  }

  public listHBastidoresCOC(idPetition: string, release: string) {
    let params = new HttpParams()
      .set("solicitud", idPetition)
      .set("release", release);
    return this.httpClient.get<any[]>(
      `${this.env}${this.listhBastidoresCOCURL}`,
      { params: params }
    );
  }

  public listCamposLI(id: string): Observable<CampoValorLI[]> {
    let params = new HttpParams().set("_identificador", id);
    return this.httpClient.get<CampoValorLI[]>(
      `${this.env}${this.listValuesCamposLI}`,
      {
        params: params,
      }
    );
  }

  public listEstadosByScreen(screen: string) {
    let params = new HttpParams().set("pantalla", screen);
    return this.httpClient.get<any[]>(
      `${this.env}${this.listValuesEstadosPorPantalla}`,
      {
        params: params,
      }
    );
  }
}
